import request from '@/utils/request'

/**
 * 数据概览页接口
 *
 * 说明：后端目前没有提供聚合统计接口，顶部四项指标复用已有的分页接口，
 * 只取 total / totalRechargeAmount 汇总字段（limit 传 1，避免拉取无用列表数据）。
 * 收入趋势、套餐占比、热门标签暂无对应接口，先由本文件提供假数据，
 * 待后端接口就绪后替换 mock 方法即可（TODO 已标注）。
 */

/**
 * 用户分页（复用用户模块接口）
 * @param {Object} params - memberVip / startDate / endDate 等
 */
export function getUserPage (params) {
  return request({
    url: '/user/user/page',
    method: 'get',
    params
  })
}

/**
 * 支付订单分页（复用订单模块接口）
 * 返回结构：{ data: { pageData: { list, total }, totalRechargeAmount } }
 * @param {Object} params - orderType（1=支付成功） / startDate / endDate 等
 */
export function getPayOrderPage (params) {
  return request({
    url: '/payOrder/payorder/page',
    method: 'get',
    params
  })
}

/**
 * 热门标签：按关联影片数取 TOP N
 * 名称和关联视频数是真实的；点击量、转化率后端暂无数据来源
 */
export function getHotTags (limit = 10) {
  return request({
    url: '/movie_tags/page',
    method: 'get',
    params: {
      page: 1,
      limit,
      sort_field: 'movie_count',
      sort_order: 'desc'
    }
  })
}

/**
 * TODO 假数据：近 N 天收入趋势
 * 后端提供按天聚合的收入统计接口后，替换为真实请求
 * @param {Number} days - 天数
 * @returns {{dates: String[], values: Number[]}}
 */
export function getRevenueTrendMock (days = 30) {
  const dates = []
  const values = []
  const base = new Date()
  for (let i = days - 1; i >= 0; i--) {
    const d = new Date(base.getTime() - i * 24 * 3600 * 1000)
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    dates.push(`${month}-${day}`)
    // 用日期做种子生成稳定的伪随机值，避免每次刷新图表都在跳动
    const seed = (d.getDate() * 37 + d.getMonth() * 91) % 100
    values.push(6000 + seed * 80 + (days - i) * 60)
  }
  return { dates, values }
}

/**
 * TODO 假数据：套餐销售占比
 * @returns {Array<{name: String, value: Number}>}
 */
export function getPackageRatioMock () {
  return [
    { name: '包月', value: 33 },
    { name: '包天', value: 22 },
    { name: '单片', value: 17 },
    { name: '终身', value: 14 },
    { name: '其他', value: 14 }
  ]
}

/**
 * TODO 假数据：热门标签的「点击量」和「转化率」
 * 标签名和关联视频数已改用 /movie_tags/page 的真实数据，
 * 这两项后端没有数据来源，按标签 id 生成稳定值占位
 */
export function mockTagMetrics (id) {
  const str = String(id || '')
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) % 100000
  }
  return {
    clicks: 1000 + (hash % 12000),
    rate: `${(4 + (hash % 90) / 10).toFixed(1)}%`
  }
}
